export { default as getLocaleFromBrowser } from './getLocaleFromBrowser'
export { default as getLocaleFromCookie } from './getLocaleFromCookie'
export { default as getLocaleFromLocalizedUrl } from './getLocaleFromLocalizedUrl'
export { default as getLocaleFromLocalStorage } from './getLocaleFromLocalStorage'
export { default as setLocaleToCookie } from './setLocaleToCookie'
export { default as getIsLocale } from './getIsLocale'
export { default as getIsLocaleSupported } from './getIsLocaleSupported'
